import OrganizationsContainer from './organizations_container';

const Organizations = OrganizationsContainer;
export default Organizations;
